/*
 * Copyright (c) 2022. American Express Company
 */

// theirs
import React from 'react';

// ours
import Typography from '../typography/Typography';
import { TypographyVariants } from 'src/types/typography-variants.enum';

// styles
import styles from './EmptyStateBox.module.scss';
import Selectors from 'src/utils/selectors';

interface EmptyStateBoxProps {
    children: string | JSX.Element;
    className?: string;
}

export default function EmptyStateBox(props: EmptyStateBoxProps): JSX.Element {
    return (
        <div className={`${props.className} ${styles.emptyStateBox}`} data-cy={Selectors.General.EMPTY_STATE_BOX}>
            {typeof props.children === 'string' ? (
                <Typography variant={TypographyVariants.BODY_BOLD}>{props.children}</Typography>
            ) : (
                props.children
            )}
        </div>
    );
}
